import React from 'react';

const MainWrapper = (props) =>(
    <div className="body">
        {props.children}
    </div>
) 

export default MainWrapper;